import apiFetch from '../apiFetch'

export default function (token, { page, pageSize, orderBy, dateToApply, dateFrom, dateTo, vinchassis }) {
  const queryParamsArray = [
    page ? `page=${page}` : null,
    pageSize ? `pageSize=${pageSize}` : null,
    orderBy ? `orderBy=${orderBy}` : null,
    dateToApply ? `dateToApply=${dateToApply}` : null,
    dateFrom ? `dateFrom=${dateFrom}` : null,
    dateTo ? `dateTo=${dateTo}` : null,
    vinchassis ? `vinChassis=${vinchassis}` : null
  ]
  const queryParams = queryParamsArray.reduce(
    (result, query, idx) => result + (query ? (result ? `&${query}` : `?${query}`) : '')
    , ''
  )
  return apiFetch({
    endPoint: `DossierFinder/PapServicesFromManager${queryParams}`,
    method: 'GET',
    body: null,
    token: token
  })
}
